import { render } from "./ProfessionalOnboardingModal.vue?vue&type=template&id=07c71d33&scoped=true"
import script from "./ProfessionalOnboardingModal.vue?vue&type=script&lang=js"
export * from "./ProfessionalOnboardingModal.vue?vue&type=script&lang=js"

import "./ProfessionalOnboardingModal.vue?vue&type=style&index=0&id=07c71d33&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c71d33"]])

export default __exports__